import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Printer, FilePdf } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { API, downloadCtn, errorText } from "./shared";

export const CtnPdfButton = ({ count, selection, filters }) => {
  const [job, setJob] = useState(null), [busy, setBusy] = useState(false), [error, setError] = useState("");
  const version = useRef(0), signature = JSON.stringify({ selection, filters });
  useEffect(() => { version.current += 1; setJob(null); setError(""); setBusy(false); }, [signature]);
  useEffect(() => {
    if (job?.status !== "bezig") return;
    let active = true;
    const timer = setInterval(async () => {
      try { const { data } = await axios.get(`${API}/export/pdf/${job.id}`); if (active) { setJob((old) => ({ ...old, ...data })); setError(""); } }
      catch (e) { if (active) { setError(errorText(e)); if ([401, 403, 404].includes(e.response?.status)) setJob(null); } }
    }, 1500);
    return () => { active = false; clearInterval(timer); };
  }, [job?.status, job?.id]);
  const generate = async () => {
    const current = ++version.current; setBusy(true); setError("");
    try { const { data } = await axios.post(`${API}/export/pdf`, { ...selection, formaat: "uitgebreid" }, { params: filters }); if (current === version.current) setJob(data); }
    catch (e) { if (current === version.current) setError(errorText(e)); }
    finally { if (current === version.current) setBusy(false); }
  };
  const download = async () => {
    setBusy(true); setError("");
    try { await downloadCtn(`export/pdf/${job.id}/download`, "CTN_artikelbladen.pdf"); }
    catch (e) { setError(errorText(e)); }
    finally { setBusy(false); }
  };
  return <div className="ctn-pdf-controls">
    <div className="ctn-actions">
      <Button variant="outline" onClick={generate} disabled={!count || busy || job?.status === "bezig"} data-testid="ctn-pdf-generate"><Printer size={18} className="mr-2" />{job?.status === "bezig" ? `PDF maken (${job.verwerkt}/${job.totaal})` : `PDF afdruk${count ? ` (${count})` : ""}`}</Button>
      {job?.status === "klaar" && <Button variant="outline" disabled={busy} onClick={download} data-testid="ctn-pdf-download"><FilePdf size={18} className="mr-2" />PDF downloaden ({job.totaal})</Button>}
    </div>
    {job?.waarschuwing && <p className="text-amber-800 text-xs mt-2" role="status" data-testid="ctn-pdf-page-size-note">{job.waarschuwing}</p>}
    {(error || job?.fout) && <p className="text-red-700 text-xs mt-2" role="alert" data-testid="ctn-pdf-error">{error || job.fout}</p>}
  </div>;
};